export class PharmacyUser {
    Id: number;
    PharmacyId: number;
    UserId: number;
    IsDefault: boolean;
    FacilityId: number;
    FullName: string;
}
